import React from 'react'
import styled from 'styled-components'
import Text, { useTranslations } from '../../utils/Text'
import media from '../../utils/media'

const Container = styled.div`
  margin-bottom: ${({ marginBText }) => marginBText || 30}px;
  margin-top: ${({ marginTText }) => marginTText}px;
  padding-left: ${({ horizontalPadding }) =>
    horizontalPadding || '0%'};
  padding-right: ${({ horizontalPadding }) =>
    horizontalPadding || '0%'};
  ${media.mobileL`
    margin-bottom: ${({ marginBText }) => marginBText || 20}px;
  `}
  ${media.tablet`
    padding-left: 0;
    padding-right: 0;
  `}
`

const TextComponent = styled.div`
  p {
    color: ${({ textColor }) => textColor || '#414141'};
    font-size: ${({ textSize }) => textSize || 18}px;
    line-height: 1.44;
    font-family: ${({ fontFamily }) => fontFamily || 'Raleway'};
    strong {
      color: ${({ accent }) => accent || '#414141'};
      font-weight: 600 !important;
    }
    em {
      font-style: normal;
      font-weight: ${({ accent }) => (accent ? 500 : 'normal')};
      color: ${({ accent }) => accent || '#414141'};
    }
    strong em {
      font-size: 23px;
      ${media.mobileL`
        font-size: 21px;
      `}
    }
    a {
      color: ${({ textColor }) => textColor || '#414141'} !important;
      text-decoration: underline !important;
      &:hover {
        color: ${({ accent }) => accent || '#414141'} !important;
      }
    }
    ${media.mobileL`
      font-size: calc(${({ textSize }) => textSize || 18}px - 2px);
    `}
  }
`

export default function BodyText({ ...props }) {
  const {
    text,
    textSize,
    textColor,
    accent,
    marginBText,
    marginTText,
    horizontalPadding,
    fontFamily,
    optional,
    linkTarget,
    ...rest
  } = props
  const textToShow = useTranslations(text, { optional })
  if (optional && textToShow === null) return null
  const show = textToShow === 'not-show'
  return (
    <>
      {!show && (
        <Container
          marginBText={marginBText}
          marginTText={marginTText}
          horizontalPadding={horizontalPadding}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...rest}
        >
          <TextComponent
            textSize={textSize}
            textColor={textColor}
            accent={accent}
            fontFamily={fontFamily}
          >
            <Text id={text} markdown linkTarget={linkTarget} />
          </TextComponent>
        </Container>
      )}
    </>
  )
}
